import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { ReportProblemsApi } from "../../../shared/nestjs/gd-all-in-one/services/report-problems.api";
import { RequestListProblemsDto, ResponseListProblemsDto, RequestGetMessage, ResponseGetMessageDto, RequestCreatMessageDto } from "../../../shared/nestjs/gd-all-in-one/dto/report-problems.dto";
import { ResponsePaging, ResponseData } from "../../../shared/nestjs/nest-responses";
import { CameraOptions } from "@ionic-native/camera";
import { CameraNative } from "../../../native/camera.native";
import { Platform } from "ionic-angular";
import { ImagePicker, ImagePickerOptions } from "@ionic-native/image-picker";
import { FileChooser } from "@ionic-native/file-chooser";
import { FilePath } from "@ionic-native/file-path";
import { IOSFilePicker } from "@ionic-native/file-picker";
import moment from "moment";
import { GDICamera } from "../../../native/greatday-plugin.native";

@Injectable()
export class ReportProblemsBloc {
  private subscriptions: Array<Subscription> = [];
  private _notifBadge: number;

  constructor(
    public nestApiProvider: NestApiProvider,
    private reportProblemsApi: ReportProblemsApi,
    private cameraNative: CameraNative,
    private imagePicker: ImagePicker,
    private platform: Platform,
    private fileChooser: FileChooser,
    private filePath: FilePath,
    private filePicker: IOSFilePicker
  ) {

  }

  dispose() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  set reportProblemNotif(data) {
    this._notifBadge = data;
  }

  get reportProblemNotif() {
    return this._notifBadge;
  }

  urlCreateMessage() {
    return this.reportProblemsApi.urlCeatemessage();
  }

  async getNativeCamera(): Promise<GDICamera> {
    try {
      const options: CameraOptions = {
        sourceType: 1
      }

      let imageData = await this.cameraNative.getPicture(options);
      return imageData;
    }
    catch (error) {
      return;
    }
  }

  async takeAlbums() {
    try {
      const options: ImagePickerOptions = {
        quality: 80
      }

      if (this.platform.is('android')) options.maximumImagesCount = 1;
      const getPicture = await this.imagePicker.getPictures(options);

      if(getPicture && getPicture.length > 1) {
        throw 'Cannot upload more than one';
      }

      console.log('TCL: getpicture', getPicture);
      const picture = getPicture[0] ? getPicture[0] : '';
      return { nativeURL: picture };
    } catch (error) {
      throw error;
    }
  }

  async takeFile() {
    let result = {
      filePath: null,
      originalName: null,
      fileType: null,
      fileName: null
    }

    try {
      if (this.platform.is("android")) {
        const url = await this.fileChooser.open();
        result.filePath = await this.filePath.resolveNativePath(url);
      } else if (this.platform.is('ios')) {
        result.filePath = await this.filePicker.pickFile();
      }

      result.originalName = result.filePath.substring(result.filePath.lastIndexOf('/') + 1);
      result.fileType = result.originalName.substring(result.originalName.lastIndexOf('.') + 1);
      result.fileName = `${moment().toISOString()}.${result.fileType}`;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async doGetNotifMessage() {
    try {
      const result = await this.getNotifMessage();
      this.reportProblemNotif = result.data;
    } catch (error) { }
  }

  processWebImage(event) {
    return new Promise((resolve) => {
      let name = event.target.files[0].name;
      let fileIMG = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      let formatImage = name.split('.').pop();
      let res = formatImage.toLowerCase();
      let options = moment().valueOf() + '.' + res;
      let type = "image";
      if (fileIMG.indexOf(res) < 0) {
        type = "file"
      }

      let base: any;
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        base = reader.result;
        const result = {
          data: base,
          options: options,
          isSelected: false,
          eventsWebview: <Array<File>>event.target.files,
          type: type
        }

        resolve(result);
      }, false);
      reader.readAsDataURL(event.target.files[0]);
    })
  }

  storageProblems() {
    const links = {
      urlDownload: 'https://sfsupport.dataon.com/api/StorageReportProblems/report/downloadFile',
      urlUpload: 'https://sfsupport.dataon.com/api/StorageReportProblems/report_problem/uploadFile',
    }

    return links;
  }

  getListReportProblems(payload: RequestListProblemsDto) {
    return new Promise<ResponsePaging<ResponseListProblemsDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.reportProblemsApi.listReportProblem(payload)
          .subscribe((response) => {
            resolve(response)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getNotifMessage() {
    return new Promise<ResponseData<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.reportProblemsApi.getNotifMessage()
          .subscribe((response) => {
            resolve(response)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getMessage(payload: RequestGetMessage) {
    return new Promise<ResponsePaging<ResponseGetMessageDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.reportProblemsApi.getMessage(payload)
          .subscribe((response) => {
            resolve(response)
          }, error => {
            reject(error)
          })
      )
    })
  }

  createMessage(payload: RequestCreatMessageDto) {
    return new Promise<ResponseData<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.reportProblemsApi.createmessage(payload)
          .subscribe((response) => {
            resolve(response)
          }, error => {
            reject(error)
          })
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/report-problems/report-problems.bloc.ts